import { fetchData } from 'services/fetchData';

import { authStore, reportStore } from 'stores';

/**
 * Function to retrieve User Manager assignments from Salesforce.
 * @returns
 */
export const getManagerAssignments = async () => {
    const { jwtToken } = authStore.getState('passwordSession').value.sessionDetails;
    const organization = reportStore.getState('currentOrg').value;
    const managerInfo = reportStore.getState('managerInfo').value;

    const httpOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`
        },
        withCredentials: true
    };

    // All other quries
    const { data, response } = await fetchData(`/salesforce/manager-assignments/${organization._id}?managerNameField=${managerInfo.managerField.QualifiedApiName}`, httpOptions);
    return { data, response };
};
